import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

/* styles */
import "/styles/modern-normalize.css";
import "/styles/global.css";
import "/styles/components/header.css";
import "/styles/components/menu.css";
import "/styles/utility.css";

export default function Menu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    home: false,
    chapters: false,
    refs: false,
  });

  const menuRef = useRef(null);

  const toggleMenu = (event) => {
    event.stopPropagation();
    setMenuOpen((prev) => !prev);
  };

  const closeCard = () => {
    setMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <>
      {/* section: desktop menu */}
      <header className=" header">
        <nav>
          <ul className="header__menu">
            <li>
              <Link className="header__link" to="/">
                Home
              </Link>
            </li>
            <li>
              <button
                onClick={() => toggleSection("chapters")}
                className="header__link"
              >
                Chapters
                {expandedSections.chapters ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="icon"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 12h14"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="icon"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 4.5v15m7.5-7.5h-15"
                    />
                  </svg>
                )}
              </button>
            </li>
            {/* Expandable Section */}
            {expandedSections.chapters && (
              <div className="menu__about-content">
                <a href="#cover" className="chapters__name" onClick={closeCard}>
                  Cover
                </a>
                <a
                  href="#prologue"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Prologue 2039
                </a>
                <a href="#intro" className="chapters__name" onClick={closeCard}>
                  Introduction
                </a>
                <a
                  href="#disclaimer"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Disclaimer
                </a>
                <a
                  href="#tutorial"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Tutorial
                </a>
                <a
                  href="#2020-2024"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Rosa 2020-2024
                </a>
                <a
                  href="#2025-2029"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Orson 2024-2029
                </a>
                <a
                  href="#2030-2034"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Indra 2030-2034
                </a>
                <a
                  href="#2035-2039"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Janey 2034-2039
                </a>
                <a
                  href="#afterword"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Afterword 2039
                </a>
                <a
                  href="#footer"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  End
                </a>
              </div>
            )}

            <li>
              <Link className="header__link" to="/reference">
                Reference
              </Link>
            </li>
          </ul>
        </nav>
      </header>
      {/* section: mobile menu */}
      <div className="menu__hamburger-wrapper btn" onClick={toggleMenu}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="icon"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </div>

      <div className={`menu ${menuOpen ? "open" : ""}`} ref={menuRef}>
        <div className="menu__content-container">
          <div className="menu__close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="icon"
              onClick={closeCard}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>

          <p className="menu__title">Menu</p>

          <div className="menu__link-container">
            {/* Home */}
            <div className="menu__home">
              <Link className="menu__home-title" to="/" onClick={closeCard}>
                Home
              </Link>
            </div>

            {/* Chapters */}
            <div className="menu__about">
              <button
                onClick={() => toggleSection("chapters")}
                className="plus-icon"
              >
                <p className="menu__about-title">Chapters</p>
                {expandedSections.chapters ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="icon"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 12h14"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="icon"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 4.5v15m7.5-7.5h-15"
                    />
                  </svg>
                )}
              </button>
            </div>

            {/* Expandable Section */}
            {expandedSections.chapters && (
              <div className="menu__about-content">
                <a href="#cover" className="chapters__name" onClick={closeCard}>
                  Cover
                </a>
                <a
                  href="#prologue"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Prologue 2039
                </a>
                <a href="#intro" className="chapters__name" onClick={closeCard}>
                  Introduction
                </a>
                <a
                  href="#disclaimer"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Disclaimer
                </a>
                <a
                  href="#tutorial"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Tutorial
                </a>
                <a
                  href="#2020-2024"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Rosa 2020-2024
                </a>
                <a
                  href="#2025-2029"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Orson 2024-2029
                </a>
                <a
                  href="#2030-2034"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Indra 2030-2034
                </a>
                <a
                  href="#2035-2039"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Janey 2034-2039
                </a>
                <a
                  href="#afterword"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  Afterword 2039
                </a>
                <a
                  href="#footer"
                  className="chapters__name"
                  onClick={closeCard}
                >
                  End
                </a>
              </div>
            )}

            {/* References */}
            <div className="menu__refs">
              <Link
                className="menu__refs-title"
                to="/reference"
                onClick={closeCard}
              >
                References
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
